import { LitElement, html } from "lit";
import { property, customElement } from "lit/decorators.js";

@customElement("featured-links")
export class FeaturedLinks extends LitElement {
  @property()
  featuredData = [];

  private finderSection = (link: any) => {
    return html` <div
      class="twf-flex twf-pb-8 lg:twf-pb-0 twf-justify-center lg:twf-max-w-full"
    >
      <img class="twf-mr-4" src="${link?.image.data.attributes.url}" />
      <p
        class="twf-font-nunito twf-font-bold twf-ml-4 twf-my-auto twf-text-sm lg:twf-text-xs lg:twf-mr-3 lg:twf-ml-3 lg:twf-max-w-full"
      >
        Awarded Best Loyalty Program
      </p>
    </div>`;
  };

  private featuredOnSection = (links: any) => {
    links.shift();
    return html`
      <div
        class="twf-pt-8 twf-border-purple-200 twf-border-t-[1px] lg:twf-flex lg:twf-pt-0 lg:twf-border-l-[1px] lg:twf-border-t-0 twf-w-full"
      >
        <p
          class="twf-text-center twf-mb-4 twf-font-nunito twf-font-bold lg:twf-text-xs lg:twf-my-auto lg:twf-ml-4 lg:twf-mr-4 lg:twf-w-28"
        >
          As Featured On
        </p>
        <div
          class="twf-grid twf-grid-cols-3 twf-gap-4 lg:twf-gap-8 lg:twf-flex twf-w-full"
        >
          ${links.map((link: any) => {
            return html`<div class="twf-m-auto twf-pb-2">
              <img src="${link.image.data.attributes.url}" />
            </div>`;
          })}
        </div>
      </div>
    `;
  };

  override createRenderRoot() {
    return this;
  }

  override render() {
    return html`<div
      class="twf-py-8 twf-px-4 twf-mx-auto lg:twf-max-w-[1320px] md:twf-px-6 lg:twf-py-[38px] lg:twf-flex 2xl:twf-py-16 twf-justify-center"
    >
      ${this.finderSection(this.featuredData[0])}
      ${this.featuredOnSection(this.featuredData)}
    </div>`;
  }
}
